import React, { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { Form, Card, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../../style/customcssfile.css";
import "../../../../style/finishorder.css";
import ViewMoreText from "../../Admin/components/ViewMoreText";
import { apiAxios } from "../../../../utils/apiAxios";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

interface CheckBoxItem {
  checkBoxID: number;
  checkBoxName: string;
  isRequired: boolean;
  isActive: boolean;
}

const CheckBoxMaster: React.FC = () => {
  const [name, setName] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [data, setData] = useState<CheckBoxItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);


  const customStyles = {


    headCells: { style: { fontSize: "15px", justifyContent: "center" } },
    cells: { style: { fontSize: "14px", } },

  };
  const token = sessionStorage.getItem("token") || "";

  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const fetchCheckBoxes = async () => {
    try {
      setLoading(true);
      const res = await apiAxios.get(`${API_BASE}/CheckBox/GetAll`, {
        headers: { AuthorizationData: token },
      });

      if (res.data?.isSuccess) {
        setData([...res.data.singleData].reverse());
      } else {
        toast.error(res.data?.status || "Failed to load");
      }
    } catch {
      toast.error("Failed to load CheckBox list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCheckBoxes();
  }, []);

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Please enter name");
      return;
    }

    const payload = {
      checkBoxID: editId ?? 0,
      checkBoxName: name.trim(),
      isRequired,
      isActive: true,
    };

    try {
      const url = editId
        ? `${API_BASE}/CheckBox/Update`
        : `${API_BASE}/CheckBox/Create`;

      const method = editId ? apiAxios.put : apiAxios.post;

      const res = await method(url, payload, {
        headers: { AuthorizationData: token },
      });

      if (res.data?.isSuccess) {
        toast.success(res.data.status);
        fetchCheckBoxes();
        handleClear();
      } else {
        toast.error(res.data?.status || "Operation failed");
      }
    } catch (err: any) {
      if (err.response?.data?.status) {
        toast.error(err.response.data.status); // 👈 "CheckBox name already exists"
      } else {
        toast.error("Operation failed");
      }
    }
  };



  const handleClear = () => {
    setName("");
    setIsRequired(false);
    setEditId(null);

  };

  const handleDelete = async () => {
    if (!deleteId) return;

    try {
      const res = await apiAxios.delete(
        `${API_BASE}/CheckBox/Delete/${deleteId}`,
        { headers: { AuthorizationData: token } }
      );

      if (res.data?.isSuccess) {
        toast.success(res.data.status);
        fetchCheckBoxes();
      } else {
        toast.error(res.data?.status || "Delete failed");
      }
    } catch {
      toast.error("Delete failed");
    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };


  const handleEdit = (row: CheckBoxItem) => {
    setName(row.checkBoxName);
    setIsRequired(row.isRequired);
    setEditId(row.checkBoxID);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  const filteredData = data.filter((x) =>
    x.checkBoxName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns: TableColumn<CheckBoxItem>[] = [
    {
      name: "ID",
      selector: (r) => r.checkBoxID,
      minWidth: "100px",
      center: true,
    },
    {
        name: (
    <div style={{ textAlign: "left", width: "100%" }}>
      Name
    </div>
  ),
      
      //selector: (r) => r.checkBoxName,
      cell: (row) => (
    <ViewMoreText text={row.checkBoxName} limit={30} />
  ),
      sortable: true,
      minWidth: "400px",
    },
    {
      name: "Is Required",
      selector: (r) => (r.isRequired ? "Yes" : "No"),
      center: true,
      minWidth: "230px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="action-btn edit"
            onClick={() => handleEdit(row)}
            title="Edit"
          >
            <i className="bi bi-pencil-square"></i>
          </button>

          <button
            className="action-btn delete"
            onClick={() => confirmDelete(row.checkBoxID)}
            title="Delete"
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      minWidth: "230px",
      center: true,
    },
  ];

  return (
    <div>
      <h4 className="mb-4">Add CheckBox</h4>
     <div className="premium-card mt-4 ">
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-2">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter checkbox name"
                  />
                </Form.Group>

                <Form.Group className="mb-3 mt-3">
                  <Form.Check
                    label="Is Required"
                    checked={isRequired}
                    className="custom-checkbox-master"
                    onChange={(e) => setIsRequired(e.target.checked)}
                  />
                </Form.Group>

                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-primary updatebtncustom" onClick={handleSave} > {editId ? "Update" : "Save"}
                  </button>
                  <button type="button" className="btn btn-secondary user-login-history-btnclear2" onClick={handleClear}> Clear
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
    
</div>
     <div className="premium-card mt-4 ">
        <h5 className="mb-3">CheckBox List</h5> 
         <div className="row">
        <div className="col-md-12 col-xl-3 col-12">
            <input
              className="form-control mb-3"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
         className="admin-delivery-table"
          progressPending={loading}
          noDataComponent="No records found"
          customStyles={customStyles}

        />

        <Modal
          show={showDeleteModal}
          dialogClassName="custom-top-modal"
          onHide={() => setShowDeleteModal(false)}

        >
          <Modal.Body className="text-center">
            <p className="mb-0 ">
              Are you sure you want to delete this checkbox?
            </p>
          </Modal.Body>

          <Modal.Footer className="justify-content-center">
            <button
              className="btn btn-primary px-4"
              onClick={handleDelete}
            >
              Yes
            </button>

            <button
              className="btn btn-secondary px-4"
              onClick={() => setShowDeleteModal(false)}
            >
              No
            </button>
          </Modal.Footer>
        </Modal>
      </div>

    </div>
  );
};

export default CheckBoxMaster;
